<script lang="ts">
	import Icon from '$lib/components/primitives/Icon.svelte';
	import Card from '$lib/components/primitives/Card.svelte';
	import { _ } from 'svelte-i18n';
</script>

<svelte:head>
	<title>{$_('pages.guides.meta.title')} - Heyweek</title>
	<meta name="description" content={$_('pages.guides.meta.description')} />
	<meta property="og:title" content="{$_('pages.guides.meta.title')} - Heyweek" />
	<meta property="og:description" content={$_('pages.guides.meta.description')} />
</svelte:head>

<div class="guides-home">
	<div class="guides-home__header">
		<h1 class="guides-home__title">{$_('guides.overview.title')}</h1>
		<p class="guides-home__description">
			{$_('guides.overview.description')}
		</p>
	</div>

	<div class="guides-home__sections">
		<div class="guides-section">
			<div class="guides-section__header">
				<Icon name="rocket" size={24} />
				<h2 class="guides-section__title">{$_('guides.overview.sections.quickStart.title')}</h2>
			</div>
			<p class="guides-section__description">{$_('guides.overview.sections.quickStart.description')}</p>
			<div class="guides-section__cards">
				<Card href="/guides/freelancer-setup" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="user" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.freelancerSetup.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.freelancerSetup.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 10 } })}</span>
				</Card>
				<Card href="/guides/team-setup" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="users" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.teamSetup.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.teamSetup.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 15 } })}</span>
				</Card>
				<Card href="/guides/first-invoice" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="file-text" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.firstInvoice.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.firstInvoice.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 5 } })}</span>
				</Card>
			</div>
		</div>

		<div class="guides-section">
			<div class="guides-section__header">
				<Icon name="workflow" size={24} />
				<h2 class="guides-section__title">{$_('guides.overview.sections.workflows.title')}</h2>
			</div>
			<p class="guides-section__description">{$_('guides.overview.sections.workflows.description')}</p>
			<div class="guides-section__cards">
				<Card href="/guides/project-workflow" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="folder" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.projectWorkflow.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.projectWorkflow.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 20 } })}</span>
				</Card>
				<Card href="/guides/time-tracking-workflow" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="clock" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.timeTracking.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.timeTracking.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 12 } })}</span>
				</Card>
				<Card href="/guides/client-collaboration" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="message-circle" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.clientCollaboration.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.clientCollaboration.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 15 } })}</span>
				</Card>
				<Card href="/guides/financial-workflow" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="dollar-sign" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.financialManagement.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.financialManagement.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 18 } })}</span>
				</Card>
			</div>
		</div>

		<div class="guides-section">
			<div class="guides-section__header">
				<Icon name="link" size={24} />
				<h2 class="guides-section__title">{$_('guides.overview.sections.integrations.title')}</h2>
			</div>
			<p class="guides-section__description">{$_('guides.overview.sections.integrations.description')}</p>
			<div class="guides-section__cards">
				<Card href="/guides/calendar-setup" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="calendar" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.calendarSetup.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.calendarSetup.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 8 } })}</span>
				</Card>
				<Card href="/guides/banking-setup" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="credit-card" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.bankingSetup.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.bankingSetup.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 10 } })}</span>
				</Card>
				<Card href="/guides/import-export" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="download" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.importExport.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.importExport.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 12 } })}</span>
				</Card>
			</div>
		</div>

		<div class="guides-section">
			<div class="guides-section__header">
				<Icon name="zap" size={24} />
				<h2 class="guides-section__title">{$_('guides.overview.sections.tipsTricks.title')}</h2>
			</div>
			<p class="guides-section__description">{$_('guides.overview.sections.tipsTricks.description')}</p>
			<div class="guides-section__cards">
				<Card href="/guides/keyboard-shortcuts" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="command" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.keyboardShortcuts.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.keyboardShortcuts.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 5 } })}</span>
				</Card>
				<Card href="/guides/automation" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="cpu" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.automation.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.automation.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 15 } })}</span>
				</Card>
				<Card href="/guides/productivity-tips" class="guide-card">
					<div class="guide-card__icon">
						<Icon name="trending-up" size={20} />
					</div>
					<h3 class="guide-card__title">{$_('pages.guides.cards.productivityTips.title')}</h3>
					<p class="guide-card__description">{$_('pages.guides.cards.productivityTips.description')}</p>
					<span class="guide-card__time">{$_('guides.overview.readTime', { values: { time: 10 } })}</span>
				</Card>
			</div>
		</div>
	</div>

	<div class="guides-home__footer">
		<div class="guides-home__help">
			<h3>{$_('guides.overview.footer.technicalDocs.title')}</h3>
			<p>{$_('guides.overview.footer.technicalDocs.text')} <a href="/docs">{$_('guides.overview.footer.technicalDocs.link')}</a> section.</p>
		</div>
		<div class="guides-home__cta">
			<h3>{$_('guides.overview.footer.needHelp.title')}</h3>
			<p>{$_('guides.overview.footer.needHelp.text')} <a href="/contact">{$_('guides.overview.footer.needHelp.link')}</a> with your questions.</p>
		</div>
	</div>
</div>

<style>
	.guides-home {
		max-width: 900px;
		margin: 0 auto;
		padding: 2rem 1.5rem;
	}

	.guides-home__header {
		margin-bottom: 2rem;
	}

	.guides-home__title {
		font-size: 1.5rem;
		font-weight: 600;
		color: var(--text-primary);
		margin-bottom: 0.5rem;
		line-height: 1.3;
	}

	.guides-home__description {
		font-size: 0.875rem;
		color: var(--text-secondary);
		line-height: 1.5;
	}

	.guides-home__sections {
		margin-bottom: 4rem;
	}

	.guides-section {
		margin-bottom: 2rem;
	}

	.guides-section__header {
		display: none; /* Hide icons to match docs style */
	}

	.guides-section__title {
		font-size: 0.75rem;
		font-weight: 600;
		color: var(--text-tertiary);
		text-transform: uppercase;
		letter-spacing: 0.1em;
		margin-bottom: 0.75rem;
	}

	.guides-section__description {
		font-size: 0.75rem;
		color: var(--text-secondary);
		margin-bottom: 0.75rem;
		line-height: 1.5;
	}

	.guides-section__cards {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
		gap: 0.75rem;
	}

	:global(.guide-card) {
		display: flex;
		flex-direction: column;
		padding: 1rem;
		background: var(--bg-secondary);
		border: 1px solid var(--border-light);
		border-radius: 6px;
		text-decoration: none;
		transition: all 0.2s ease;
		position: relative;
		min-height: 90px;
	}

	:global(.guide-card:hover) {
		border-color: var(--border-default);
		background: var(--bg-tertiary);
	}

	.guide-card__icon {
		display: none; /* Hide icon to match docs style */
	}

	.guide-card__title {
		font-size: 0.875rem;
		font-weight: 500;
		color: var(--text-primary);
		margin: 0 0 0.375rem 0;
		line-height: 1.4;
	}

	.guide-card__description {
		font-size: 0.75rem;
		color: var(--text-tertiary);
		margin: 0;
		line-height: 1.5;
		flex: 1;
	}

	.guide-card__time {
		font-size: 0.75rem;
		color: var(--text-tertiary);
		margin-top: 0.5rem;
		opacity: 0.7;
	}

	.guides-home__footer {
		margin-top: 4rem;
		padding-top: 2rem;
		border-top: 1px solid var(--border-light);
	}

	.guides-home__help,
	.guides-home__cta {
		margin-bottom: 1.5rem;
	}

	.guides-home__help h3,
	.guides-home__cta h3 {
		font-size: 0.875rem;
		font-weight: 500;
		color: var(--text-primary);
		margin: 0 0 0.375rem 0;
	}

	.guides-home__help p,
	.guides-home__cta p {
		font-size: 0.75rem;
		color: var(--text-secondary);
		margin: 0;
		line-height: 1.5;
	}

	.guides-home__help a,
	.guides-home__cta a {
		color: var(--text-primary);
		text-decoration: underline;
		font-weight: normal;
	}

	.guides-home__help a:hover,
	.guides-home__cta a:hover {
		color: var(--accent-primary);
	}


	@media (max-width: 768px) {
		.guides-home {
			padding: 2rem 1rem;
		}

		.guides-section__cards {
			grid-template-columns: 1fr;
		}
	}
</style>